import * as z from "zod";
import { assetSchema } from "./asset";

export const messageAttachmentSchema = z.object({
  id: z.string(),
  attachmentType: z.enum(["image", "video", "audio", "document"]),
  asset: assetSchema,
});
